module.exports = __webpack_public_path__ + "static/media/gris-monitor-diagrama.f3686612.png";